import { Temporal } from "@js-temporal/polyfill";
import Cookies from "js-cookie";
import { redirectTo } from "./BrowserRedirect";

const checkFrequency = 10000; // Check every 10 seconds

function checkSessionExpiration() {
    const expirationCookieName = 'eCargoIdentityExpiration';

    const pagesNotRequiringUserToBeLoggedIn = [ '/App/Auths/LogIn', '/App/Auths/RecoverAccount', '/App/Auths/ResetPassword' ];
    const isPageRequiringValidSessionCookie = !pagesNotRequiringUserToBeLoggedIn.some(
        path => window.location.pathname.localeCompare(path, undefined, { sensitivity: "base" }) === 0
    );
    if (!isPageRequiringValidSessionCookie) {
        return false;
    }

    const expirationCookie = Cookies.get(expirationCookieName);

    if (!expirationCookie) {
        redirectToLogin();
        return true;
    }

    const expirationTime = Temporal.Instant.from(expirationCookie);
    const now = Temporal.Now.instant();
    const estimatedTimeOfNextCheck = now.add({ milliseconds: checkFrequency });

    if (Temporal.Instant.compare(expirationTime, estimatedTimeOfNextCheck) <= 0) {
        Cookies.remove(expirationCookieName);
        redirectToLogin();
        return true;
    }

    return false;
}

/**
 * Creates a watchdog that monitors the eCargoIdentityExpiration cookie and
 * redirects to the login page when the session is about to expire.
 *
 * The watchdog runs periodically and checks if the session will expire before
 * the next check interval.
 *
 * Note that this is not a security feature, but rather a user experience
 * improvement. Security is purely handled by the server using the
 * eCargoIdentity cookie.
 *
 * @returns A cleanup function that stops the watchdog when called.
 */

function install() {
    const intervalId = setInterval(() => {
        checkSessionExpiration();
    }, checkFrequency);

    return () => clearInterval(intervalId);
}

function shouldAbortPageLoad() {
    return checkSessionExpiration();
}

function redirectToLogin() {
    redirectTo('/App/Auths/LogIn?ReturnUrl=' + encodeURIComponent(window.location.pathname + window.location.search));
}

export default {
    install,
    shouldAbortPageLoad
};
